import { render, staticRenderFns } from "./userSink.vue?vue&type=template&id=5e03ec2b&"
import script from "./userSink.vue?vue&type=script&lang=js&"
export * from "./userSink.vue?vue&type=script&lang=js&"
import style0 from "./userSink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports